import ArchiveTitle from './ArchiveTitle';

export default ArchiveTitle;
